module.exports = __webpack_public_path__ + "img/fashion_31.2fe37bb8.jpg";